import { openBlock as t, createElementBlock as n, mergeProps as s, createElementVNode as o } from "vue";
import { _ as c } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const L = {};
function m(r, e) {
  return t(), n("svg", s(r.$attrs, {
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }), e[0] || (e[0] = [
    o("g", { id: "X" }, [
      o("path", {
        id: "Icon",
        d: "M5.05608 5L13.9361 17.1343L5 27H7.01116L14.8347 18.3624L21.1559 27H28L18.6203 14.1832L26.938 5H24.9268L17.7217 12.955L11.9001 5H5.05608ZM8.01364 6.51397H11.1578L25.042 25.4858H21.8978L8.01364 6.51397Z"
      })
    ], -1)
  ]), 16);
}
const d = /* @__PURE__ */ c(L, [["render", m]]);
export {
  d as default
};
